module.exports = __webpack_public_path__ + "assets/img/chop_active.07556ea4.png";